import axios from 'axios'

function apiLocal () {
  return axios.create({
    // baseURL: 'http://localhost:3000'
    // baseURL: 'https://parse.leanapp.cn'
    baseURL: 'https://shcparse.leanapp.cn/'
  })
}

function apiMj () {
  return axios.create({
    baseURL: 'https://1ulsksiu.api.lncld.net/1.1/',
    timeout: 5000,
    headers: {
      'X-LC-Id': '1UlsKsiUTHpNkAyAKSWVW1oo-gzGzoHsz',
      'X-LC-Key': 'MeyXCB3GkeYmQkQFOacuTSMU'
    }
  })
}

function apiMh () {
  return axios.create({
    baseURL: 'https://w7myuj68.api.lncld.net/1.1/',
    timeout: 5000,
    headers: {
      'X-LC-Id': 'w7mYuj68AXhJLgRDEi4b5Q2T-gzGzoHsz',
      'X-LC-Key': 'xVqGhDAXiKgSexaqbGw2M91b'
    }
  })
}

function apiMhn () {
  return axios.create({
    baseURL: 'https://f82ocash.api.lncld.net/1.1/',
    timeout: 5000,
    headers: {
      'X-LC-Id': 'f82OcAshk5Q1J993fGLJ4bbs-gzGzoHsz',
      'X-LC-Key': 'O9COJzi78yYXCWVWMkLqlpp8'
    }
  })
}

// shc
function apiShc () {
  return axios.create({
    baseURL: 'https://f9tyt5vs.api.lncld.net/1.1/',
    timeout: 5000,
    headers: {
      'X-LC-Id': 'F9tyT5VsLXLCAqxKvTHqzmvP-gzGzoHsz',
      'X-LC-Key': '17eIyz42rRL1YubtKE5MgLHm'
    }
  })
}

export {
  apiMj, apiLocal, apiMh, apiMhn, apiShc
}



// WEBPACK FOOTER //
// ./src/services/Api.js